import { PropsCourseTopicForm } from '@/domains/course-topic/entities';
import * as yup from 'yup';

export const validateCourseTopic = (props: PropsCourseTopicForm) => {
  const schemaCourseTopic = yup.object().shape({
    name: yup.string().required('Name is empty').trim(),
    description: yup.string().required('Description is empty').trim(),
    isActive: yup.boolean().optional(),
  });

  return { schemaCourseTopic };
};
